import { usePanel } from '../lib/panelContext'

export default function Agents() {
  const { onlineAgents } = usePanel()

  return (
    <div className="page-body">
      <header className="page-head">
        <h1>Agents</h1>
        <p>Voice workers that can join a chat.</p>
      </header>

      <section className="panel-section">
        <ul className="panel-list" data-testid="agent-list">
          {onlineAgents.length === 0 ? (
            <li className="panel-hint">No workers yet.</li>
          ) : (
            onlineAgents.map((agent) => {
              const primary = agent.worker_id || agent.id
              const label = agent.name || agent.livekit_agent_name || ''
              return (
                <li key={agent.id}>
                  <div className="panel-item" data-testid={`agent-row-${agent.id}`}>
                    <span className="mono">{primary}</span>
                    <span className="panel-badge">
                      {label && label !== primary ? `${label} · ` : ''}
                      {agent.online ? 'online' : 'offline'}
                    </span>
                  </div>
                </li>
              )
            })
          )}
        </ul>
      </section>
    </div>
  )
}
